/**
 * Published trips (customer-facing shared loads) — staff API
 */

import api from "../../../shared/api.jsx";
import { logError, logInfo } from "../../../shared/utils/logger.js";

const BASE = "/published-trips";

export async function fetchByInternalTripId(internalTripId) {
  try {
    const response = await api.get(
      `${BASE}/by-internal-trip/${encodeURIComponent(internalTripId)}`
    );
    return response?.data ?? null;
  } catch (error) {
    if (error.status === 404) return null;
    logError("Failed to fetch published trip by internal id", {
      internalTripId,
      error: error.message,
    });
    throw error;
  }
}

export async function fetchSuggestedFields(internalTripId) {
  const response = await api.get(
    `${BASE}/by-internal-trip/${encodeURIComponent(internalTripId)}/suggested-fields`
  );
  return response?.data ?? {};
}

export async function fetchPublishedTripById(publishedTripId) {
  try {
    const response = await api.get(
      `${BASE}/${encodeURIComponent(publishedTripId)}`
    );
    return response?.data ?? null;
  } catch (error) {
    if (error.status === 404) return null;
    logError("Failed to fetch published trip", {
      publishedTripId,
      error: error.message,
    });
    throw error;
  }
}

export async function publishFromInternalTrip(internalTripId, publicFields) {
  const response = await api.post(
    `${BASE}/from-trip/${encodeURIComponent(internalTripId)}`,
    publicFields
  );
  logInfo("Published shared load", { internalTripId });
  return response?.data ?? null;
}

export async function updatePublishedTrip(publishedTripId, updates) {
  const response = await api.patch(
    `${BASE}/${encodeURIComponent(publishedTripId)}`,
    updates
  );
  return response?.data ?? null;
}

export async function unpublishPublishedTrip(publishedTripId) {
  await api.post(
    `${BASE}/${encodeURIComponent(publishedTripId)}/unpublish`
  );
  logInfo("Unpublished shared load", { publishedTripId });
}
